// extracted by mini-css-extract-plugin
export default {"ShowTypeTab":"ShowTypeTab_ShowTypeTab__nNx8y","armBandStart":"ShowTypeTab_armBandStart__+jgsx","hint":"ShowTypeTab_hint__3QgOt","showTypeWrap":"ShowTypeTab_showTypeWrap__JDN6y"};